// skills/fishing/index.js
// Fishing skill registration with skill registry

import { skillRegistry } from '../../core/skillRegistry.js';
import { renderFishingUI, updateFishingUI, initFishingUI, toggleFishing, upgradeRod } from './fishingUI.js';

/**
 * Fishing skill configuration
 */
const fishingConfig = {
    id: 'fishing',
    name: 'Fishing',
    icon: '🎣',
    iconImage: 'assets/icons/skill_icons/fishing.png',
    description: 'Catch fish from various spots',

    tabs: [
        { id: 'spots', name: 'Fishing Spots', default: true },
    ],

    render(params = {}) {
        renderFishingUI();
    },

    update() {
        updateFishingUI();
    },

    init() {
        initFishingUI();
    },

    cleanup() {
        // Nothing to cleanup for now
    }
};

skillRegistry.register('fishing', fishingConfig);

if (typeof window !== 'undefined') {
    window.fishingUI = {
        toggleFishing,
        upgradeRod
    };
}

export default fishingConfig;
